import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent {
  @Input() currentPage!: number;
  @Input() totalItems!: number;
  @Input() itemsPerPage!: number;
  @Input() paginationType: string = "type1";

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  ngOnInit() {
    // console.log(this.currentPage, this.totalItems, this.itemsPerPage, "pagination")
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  getPages(): number[] {
    const totalPages = this.totalPages;
    const currentPage = this.currentPage;

    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      let startPage: number;
      if (currentPage <= 3) {
        startPage = 1;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 4;
      } else {
        startPage = currentPage - 2;
      }
      return Array.from({ length: 5 }, (_, i) => startPage + i);
    }
  }

  onNext(): void {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  onPrevious(): void {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  gotToFirst(): void {
    this.pageChange.emit(1);
  }

  gotToLast(): void {
    this.pageChange.emit(this.totalPages);
  }


  onPageSelect(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  onPageSizeChange(pageSize: any): void {
    // this.pageChange.emit(1);
    this.pageSizeChange.emit(pageSize.target.value);
  }
}
